import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import Loader from "../../ui/Loader";

const renderChange = change => {
	const { details, userInformation, changedAt, ticksAgo } = change;
	const timeAgo = changedAt ? moment(changedAt).fromNow() : "";
	return (
		<div key={ticksAgo} className="change">
			<h5>{details}</h5>
			<p className="caption-text">
				{timeAgo} by {userInformation}
			</p>
		</div>
	);
};

const History = props => {
	const { visible, history, requestResolved, error, reset, length, interval, seeMore, seeLess } = props;
	let content;
	if (requestResolved && visible && history && history.length > 0) {
		content = history.slice(0, length).map(change => renderChange(change));
	} else if (requestResolved && !!error) {
		content = <p>{error}</p>;
		setTimeout(reset, 2000);
	} else if (!requestResolved && visible) {
		content = (
			<div className="loader">
				<Loader />
			</div>
		);
	}
	return (
		<div className={`history ${visible ? "on" : "off"}`}>
			<h4 className="title">Change History</h4>
			{content}
			{!(history && length >= history.length) && (
				<button onClick={e => seeMore(e)} className="pagination">
					SEE MORE
				</button>
			)}
			{length > interval && (
				<button onClick={e => seeLess(e)} className="pagination">
					SEE LESS
				</button>
			)}
		</div>
	);
};

History.propTypes = {
	visible: PropTypes.bool,
	history: PropTypes.array,
	requestResolved: PropTypes.bool,
	error: PropTypes.string,
	reset: PropTypes.func,
};

export default History;
